import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { QuillModule } from 'ngx-quill';
import { GetDataService } from '../../../services/userService/get-data.service';
import { Contents as RuleNode } from '../../../Common/rules.module';
import { AuthServiceService } from '../../../services/auth-service.service';
import { showCustomeAlert, showCustomeAlertOkCancel } from '../../../services/Alert/alert.service';

@Component({
  selector: 'app-rules',
  standalone: true,
  imports: [CommonModule, FormsModule, QuillModule, ReactiveFormsModule],
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.scss']
})

export class RulesComponent implements OnInit {
  constructor(private _route: Router, private _service: GetDataService, private _authService: AuthServiceService) { }

  UserDetails: any;
  //Versions
  versions: any[] = [];
  selectedVersion: string | null = null;

  version: number = 0;
  // sectionId: any;

  // Top-level nodes (sections)
  sections: RuleNode[] = [];
  confirmedSections: any = [];
  // abandonContent: any = [];

  editorConfig = {
    toolbar: [
      ['blockquote', 'code-block'],
      ['bold', 'italic', 'underline'],
      [{ 'align': [] }],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['clean'],
      [{ 'direction': 'rtl' }],
    ]
  };

  ngOnInit() {
    this.UserDetails = this._authService.getUserSession();
    this.fetchVersions();
    this.addNewSection();
  }

  //Fetch Versions from DB.
  fetchVersions() {
    this._service.getVersions().subscribe(
      data => {
        console.log(this.versions,data);
        if(data.versions.length > 0){
          this.versions = data.versions;
          console.log(this.versions);
          this.versions.push(Math.floor(Math.max(...data.versions)) + 1)
        }else{
          this.versions.push('1.0');
        }
      },
    )
  }


  // Adds a new section after confirming all unconfirmed sections are confirmed and collapsed.
  addSection() {

    if (this.sections.length === 0) {
      // Directly add first section if no sections exist
      this.addNewSection();
      return;
    }

    if (!this.selectedVersion) {
      showCustomeAlert("info", "Please Select Version !!", "Version");
      return;
    }
    // Collapse all existing sections
    this.sections.forEach(section => section.collapsed = true);

    // Check for unconfirmed sections
    const unconfirmedSections = this.sections.filter(section => !section.confirm);
    if (unconfirmedSections.length > 0) {
      showCustomeAlertOkCancel("warning", 
        "Please confirm all unconfirmed sections before adding a new one.",
        "Confirm Sections",
        () => this.confirmAllSection(unconfirmedSections));
    } else {
      this.addNewSection();
    }
  }

  addNewSection() {
    this.sections.push({
      title: '',
      content: '',
      subContents: [],
      collapsed: false, // New section starts expanded
      confirm: false,
      version: '',
      parentContentID: null,
      contentTypeID: 1,
      abandonedNote: '',
      displayOrder: 1,
      _orignalTitle: '',
      _orignalDescription: '',
      _prevVersion: ''
    });
  }

  addChild(parent: RuleNode) {
    if (parent.title.trim() != "" && parent.content.trim() != "") {
      parent.subContents.push({
        title: '',
        content: '',
        subContents: [],
        collapsed: false,
        version: '',
        parentContentID: 0,
        contentTypeID: 1,
        abandonedNote: '',
        displayOrder: 1,
        _orignalTitle: '',
        _orignalDescription: '',
        _prevVersion: ''
      });
    } else {
      showCustomeAlert("warning", "Empty fields are not acceptable..!", "Fill Inputs");
    }
  }

  //QUILLLL_EDITORRR
  updatePlainText(event: any, node: RuleNode) {
    node.content = event.editor.getText().trim();
  }

  confirmSection(node: any) {
    if (!this.selectedVersion) {
      showCustomeAlert("info", "Please Select Version !!", "Version")
      return;
    }
    else {
      node.collapsed = true;
      node.confirm = true;
      
      if (node.subContents || Array.isArray(node.subContent)) {
        node.subContents.forEach((rule: any) => {
          this.confirmSection(rule);
        })
      }

      this.confirmedSections.push(node);
    }
  }

  confirmAllSection(unconfirmedSections: any) {
    // Confirm and collapse all sections
    unconfirmedSections.forEach((section: any) => {
      section.confirm = true;
      section.collapsed = true;
    });

    // Delay UI update to ensure Quill editor collapses
    setTimeout(() => {
      this.sections = [...this.sections]; // Trigger Angular change detection

      showCustomeAlertOkCancel("success", 
        "All sections have been confirmed and collapsed.", 
        "Confirmed!", 
        () => this.addNewSection());
    }, 100);
  }

  //Edited Data for abandon
  filterIsEdited(data: any[]): any[] {
    let result: any[] = [];
    for (const item of data) {

      if (item.isEdited) {
        result.push({ ...item, subContents: [], version: item.version, abandonedNote: "Abandoned : " + item.abandonedNote });
      }

      // Recurse into subrules if they exist
      if (item.subContents && item.subContents.length > 0) {
        result = result.concat(this.filterIsEdited(item.subContents));
      }
    }
    return result;
  }


  confirmPDF() {
    if (this.confirmedSections.length) {
      this.confirmedSections.forEach((each:any) => {
        const requestBody = {
          node: each,
          version: this.selectedVersion,
        }
        this._service.addData(requestBody, this.UserDetails.userName, 0).subscribe(
          response => {
            if (response) {
              showCustomeAlert('success', "The Section you have submitted is successfully added..!", "New Section Added");
              this._route.navigate(['admin'])
            }
          },
          error => {
            showCustomeAlert('error', "Something went wrong while Adding new content.", "Error");
            this._route.navigate(['admin'])
          }
        )
      });
      this.confirmedSections = [];
    } else {
      showCustomeAlert("error", "No data to save", "Error");
    }
  }

  toggleCollapse(node: RuleNode) {
    node.collapsed = !node.collapsed;
  }


  firstUnconfirmedSectionIndex(): number {
    return this.sections.findIndex(section => !section.confirm);
  }
}